<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!--for overlay :loading="get_ay_std_ft_loader" -->
    <!--api- 1  -->
    <v-card class="no-display box">
      <v-toolbar flat class="toolbar" dense align="center" justify="center">
        <v-toolbar-title>Roll Call</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
       <v-row justify="center" dense>
                    <v-col sm="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay"
                            item-value="id" label="Academic Year" rounded outlined persistent-hint
                            hint="Please Select Academic Year" @change="getStd()"/>
                    </v-col>
                    <v-col sm="3" v-if="academicyear">
                        <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id"   label="standard" multiple outlined persistent-hint
                            hint="Please Select Standard" @change="getaystddivonrole()" />
                    </v-col>

                    <v-col sm="3" v-if="division_list!=''">
                        <p><v-icon color="error">*</v-icon><b> Division</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="division" :items="division_list"
                            item-text="name" item-value="id" label="Division" multiple outlined persistent-hint
                            hint="Please Select Division" />
                    </v-col>

                     <v-col sm="3" v-if="academicyear && standard.length >0 && division.length >0">
                       <p><v-icon color="error"></v-icon></p>
                      <v-btn @click="getRollCall()" :loading="save_btn_load" color="info">Fetch</v-btn>
                     </v-col>

                </v-row>
      </v-card-text>
    </v-card>
    <br />
    <!-- api-1 ends -->
    <!-- api-3 -->

    <v-card class="box" v-if="records.length != 0">
      <v-toolbar flat class="toolbar" dense align="center" justify="center">
        <v-toolbar-title>Report</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row justify="center">
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details
            class="no-display"></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2">
          <v-btn class="ma-2 no-display" rounded outlined color="warning" @click="print()">
            <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <div id="my-table-id">
        <v-data-table id="print" :headers="header_list" :items="records" sort-by class="elevation-1 mytable"
          :search="search" :items-per-page="-1">
          <template v-slot:[`item.lid`]="{ item }">
                <v-btn title="Edit" class="ma-2" tile small @click="edit_profile(item.lid)">
                    <v-icon color="success">mdi-pencil</v-icon>
                </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" fullscreen>
          <v-card>
              <v-toolbar class="toolbar" flat dense>
                  <v-toolbar-title>
                      <strong> Learner Profile </strong>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn fab small color="white" outlined icon @click="dialog = false"><v-icon> mdi-close </v-icon></v-btn>
              </v-toolbar>
              <v-card class="box">
                <br/>
                <student-profile-tab :lid="lid"></student-profile-tab>
              </v-card>
              <v-row justify="center">
                  <v-btn class="button" @click="dialog = false">Cancel</v-btn>
              </v-row>
          </v-card>
      </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import StudentProfileTabs from "./StudentProfileTabs";
export default {
    components: {
            "student-profile-tab": StudentProfileTabs,
        },
  data: () => ({
    status_list: [],
    search: "",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    fetch_btn_load: false,
    header_list: [],
    records: [],
    query: { limit: 10, offset: 0, sort: "", order: "" },
    xls_header: [],
    xls_title: [],
    printing: null,dialog:false,lid:null,
    academicyear: "",
    standard_list: [],
    standard: [],
    division_list: [],
    division: [],  ay_list: [],records: [],save_btn_load:false,
  }),
  watch: {
    std() {
      this.getDivOff();
    },
    current_academic_year() {
      this.getDivOff();
    },
  },
  methods: {
      getRollCall() {
            this.save_btn_load = true;
             let div = [];
             let standard = [];
             for (var i = 0; i < this.division.length; i++) {
                   div.push(this.division[i]);
                }
                 for (var i = 0; i < this.standard.length; i++) {
                   standard.push(this.standard[i]);
                }
            const formData = {
                    ay: this.academicyear.id,
                    standard: standard,
                    div: div,
            }
            axios
                .post("/AdmissionReport/getStudentRollCall", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                      this.records = res.data.records;
                        this.header_list = res.data.header_list;
                    this.save_btn_load = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason); // show snackbar
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                });
        },
    edit_profile(lid){
      this.lid=lid
      this.dialog=true
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
            axios
                .post("App/commonAy")
                .then((res) => {
                    if (res.data.msg == '200') {
                        this.ay_list = res.data.ay_list;
                        // this.standard_list = res.data.standard_list;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })

        },
        getaystddivonrole() {
            const data = {
                ay: this.academicyear.id,
                standard: this.standard,
            };
            this.init_loader = true;
            axios
                .post("/AdmissionReport/getStandardDivisions", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                      this.division_list = res.data.division_offering_list;
                    } else {
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.init_loader = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.init_loader = false;
                })
                .finally(() => {
                    this.init_loader = false;
                });
        },
        get_divisions() {
            const formData = {
                ay: this.academicyear.id,
                standard: this.standard,
            };
            this.division = [];
            axios
                .post("/Communication/get_standard_divisions", formData)
                .then((res) => {
                    if (res.data.flag == "Yes") {
                        this.division_list = res.data.division_list;
                    }
                })


        },
           getstdonrole() {
            const data = {
                ay: this.academicyear.id,
            };
            this.init_loader = true;
            axios
                .post("/commonAPI/getStdOnRole", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                      this.standard_list = res.data.standard_list;
                    } else {
                      sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.init_loader = false;
                })
                .catch((error) => {
                    this.onerror(error);
                    this.init_loader = false;
                })
                .finally(() => {
                    this.init_loader = false;
                });
        },
        getStd(){
          this.standard = []; 
          this.division = [];
          this.getstdonrole();
        }
  },
  mounted() {
    this.onLoad();
  },
};
</script>
<style scoped>
.allot-btn,
.allot-icon,
.info-icon {
  transition: 0.3s;
}

.allot-btn:hover .allot-icon {
  color: white;
}

.allot-btn:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
}

.info-icon:hover {
  background-color: #193a9a !important;
  border-color: #193a9a !important;
  color: white;
  border-radius: 100%;
}

.table-sub-title {
  margin-left: 1%;
  font-weight: 500;
  color: #999;
}

@media print {
  body {
    height: 100%;
    width: 100%;
  }

  .no-display {
    display: none !important;
  }

  .v-data-footer,
  .v-data-footer__select,
  .v-data-footer__pagination {
    display: none !important;
    visibility: hidden !important;
  }

  .v-data-table table,
  .v-data-table__wrapper {
    width: 100% !important;
    display: block !important;
  }

  table,
  th,
  td {
    border-collapse: collapse !important;
    border: 1px solid black !important;
    width: 100%;
    text-align: right !important;
  }
}
</style>
